export type VoiceContext = { eventId: string } | { logId: number };
export type VoiceTranscript =
  | { status: 'idle' | 'pending' | 'processing' }
  | { status: 'ready'; text: string; language: 'ru' }
  | { status: 'error'; error: string };

export function voiceTranscriptError(code: string): string {
  if (code === 'too-long') return 'Расшифровка доступна для голосовых до 5 минут.';
  if (code === 'source-changed') return 'Запись изменилась. Откройте сообщение заново.';
  if (code === 'timeout') return 'Не успели распознать запись. Можно повторить.';
  return 'Не удалось распознать запись. Можно повторить.';
}
